import type { FilterValueStatus } from "@octopusdeploy/octopus-server-client";
import { FilterValueStatusValues } from "@octopusdeploy/octopus-server-client";
import { createQueryParam, numberQueryParam, optionalStringQueryParam, useQueryStringParams } from "@octopusdeploy/portal-routes";
import { useMemo } from "react";
import type { ProjectTenantVariablesFilterState } from "~/areas/projects/components/Variables/TenantVariables/FiltersBar";
export function useCommonTemplatesFilterState(): [
    ProjectTenantVariablesFilterState,
    (filter: ProjectTenantVariablesFilterState) => void
] {
    const searchParameter = optionalStringQueryParam("search");
    const tenantParameter = optionalStringQueryParam("tenant");
    const tagsParameter = optionalStringQueryParam("tags");
    const valueStatusParameter = createQueryParam("valueStatus", validateValueStatus, (v) => v);
    const pageNumberParameter = numberQueryParam("pageNumber");
    const libraryVariableSetIdsParameter = optionalStringQueryParam("libraryVariableSetIds");
    const [filter, setFilter] = useQueryStringParams([searchParameter, tenantParameter, tagsParameter, valueStatusParameter, pageNumberParameter, libraryVariableSetIdsParameter]);
    function setProjectTenantVariablesFilterState(filter: ProjectTenantVariablesFilterState) {
        setFilter({
            search: filter.filterByName,
            tenant: filter.filterByTenants && filter.filterByTenants.length > 0 ? filter.filterByTenants.join(",") : undefined,
            tags: filter.filterByTags.length > 0 ? filter.filterByTags.join(",") : undefined,
            valueStatus: filter.filterByValueStatus,
            pageNumber: filter.pageNumber,
            libraryVariableSetIds: filter.filterByLibraryVariableSetIds && filter.filterByLibraryVariableSetIds.length > 0 ? filter.filterByLibraryVariableSetIds.join(",") : undefined,
        });
    }
    const projectTenantVariablesFilterState = useMemo((): ProjectTenantVariablesFilterState => ({
        filterByName: filter.search,
        filterByEnvironments: [],
        filterByTenants: filter.tenant ? filter.tenant.split(",") : [],
        filterByTags: filter.tags ? filter.tags.split(",") : [],
        filterByValueStatus: filter.valueStatus,
        filterByTemplateId: undefined,
        filterByLibraryVariableSetIds: filter.libraryVariableSetIds ? filter.libraryVariableSetIds.split(",") : [],
        filterByProjectIds: [],
        pageNumber: filter.pageNumber ?? 1,
    }), [filter.search, filter.tenant, filter.tags, filter.valueStatus, filter.pageNumber, filter.libraryVariableSetIds]);
    return [projectTenantVariablesFilterState, setProjectTenantVariablesFilterState];
}
function validateValueStatus(valueStatus: string | undefined): FilterValueStatus | undefined {
    if (valueStatus === undefined)
        return undefined;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const possibleStatus = valueStatus as FilterValueStatus;
    return Object.values(FilterValueStatusValues).includes(possibleStatus) ? possibleStatus : undefined;
}
